import React from 'react';
import styles from './Circle.module.css';

interface ICircle {
  callPagerDutyCreateIncidentHandler: () => void;
}

const Circle = ({ callPagerDutyCreateIncidentHandler }: ICircle) => {
  return (
    <div className={styles.circleContainer} data-testid={'circleDivTestId'}>
      <button
        onClick={callPagerDutyCreateIncidentHandler}
        type={'button'}
        className={styles.circle}>
        <span className={styles.circleText}>Create Incident</span>
      </button>
    </div>
  );
};

export default Circle;
